import { Component } from '@angular/core';

// Relative, not via '@shared/components': that barrel re-exports this component's own folder, and
// the resulting cycle leaves AppVersionComponent undefined when the decorator runs.
import { AppVersionComponent } from '../../app-version/app-version.component';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  imports: [AppVersionComponent],
  standalone: true,
})
export class AuthLayoutComponent {}
